import { useEffect, useState } from "react";
import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  updateParams,
  updateVideoPageState,
} from "../../../Pages/Video/VideoActions";
import { submitUnFlaggedVideo } from "../../SharedActions";
import "./FlaggedModal.scss";
import { useNavigate } from "react-router-dom";
import { usePrevious } from "../../CustomHooks";

export default () => {
  const [loading, setLoading] = useState(false);
  const confirmUnflag = useSelector(
    (state) => state.videoPageStates.confirmUnflag
  );

  const videoTab = useSelector((state) => state.videoParams.tab);
  const successfullyUnFlagged = useSelector(
    (state) => state.videoPageStates.successfullyUnFlagged
  );

  const flaggedVideosCheckList = useSelector(
    (state) => state.videoPageStates.flaggedVideosCheckList
  );

  const isVideoDetailPage = useSelector(
    (state) => state.videoPageStates.isVideoDetailPage
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const prevSuccessfullyUnFlagged = usePrevious(successfullyUnFlagged);

  const sumbitUnflagg = () => {
    submitUnFlaggedVideo(flaggedVideosCheckList)
      .then((response) => {
        if (response) {
          setLoading(false);
          dispatch(
            updateVideoPageState({
              successfullyUnFlagged: true,
            })
          );
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (isVideoDetailPage) {
      if (
        prevSuccessfullyUnFlagged &&
        prevSuccessfullyUnFlagged !== successfullyUnFlagged
      ) {
        navigate("/videos");
        dispatch(updateParams({ reFetch: true }));
      }
    }
  }, [isVideoDetailPage, confirmUnflag, successfullyUnFlagged]);

  return (
    <Modal
      size="sm"
      style={{ maxWidth: "540px" }}
      isOpen={confirmUnflag}
      className="ConfirmUnflag modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X
          size={30}
          role="button"
          className="closeBtn"
          onClick={() => {
            successfullyUnFlagged
              ? dispatch(
                  updateVideoPageState({
                    successfullyUnFlagged: false,
                    confirmUnflag: false,
                    flaggedVideosCheckList: [],
                    flaggedChecks: false,
                    flagSelectAll: false,
                  })
                )
              : dispatch(
                  updateVideoPageState({
                    confirmUnflag: false,
                    flaggedVideosCheckList: [],
                  })
                );
          }}
        />
      </ModalHeader>
      <ModalBody className="p-0">
        {!successfullyUnFlagged ? (
          <>
            <div className="d-flex justify-content-center">
              <div className="mb-2">
                <h2 style={{ lineHeight: "44px", color: "black" }}>
                  Unflagged videos will show in <strong>“{videoTab}”</strong>{" "}
                  Are you sure you want to unflag{" "}
                  {flaggedVideosCheckList.length == 1
                    ? "this"
                    : flaggedVideosCheckList.length}{" "}
                  video{flaggedVideosCheckList.length > 1 ? "s" : null}?
                </h2>
              </div>
            </div>
            <div className="d-flex justify-content-between ">
              <Button
                className="video-process-btn"
                size="lg"
                color="outline-primary"
                onClick={() => {
                  dispatch(
                    updateVideoPageState({
                      confirmUnflag: false,
                      flaggedVideosCheckList: [],
                    })
                  );
                }}
              >
                No
              </Button>
              <Button
                className="video-process-btn"
                size="lg"
                color="primary"
                onClick={sumbitUnflagg}
                disabled={loading}
              >
                Yes
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <div className="mb-2">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={
                      require(`@src/assets/images/vyrill/flagged-success.png`)
                        .default
                    }
                    width={40}
                    alt=""
                  />
                  <div
                    style={{
                      color: "#23BBB8",
                      fontSize: "12px",
                      lineHeight: "54.5px",
                    }}
                  >
                    {videoTab === "Competition" ? "Competitors" : videoTab}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <h2
                    style={{
                      lineHeight: "44px",
                      color: "black",
                      width: "64%",
                      textAlign: "center",
                    }}
                  >
                    {flaggedVideosCheckList.length == 1
                      ? "This video has"
                      : `${flaggedVideosCheckList.length} videos have`}{" "}
                    been moved to “
                    {videoTab === "Competition" ? "Competitors" : videoTab}”
                  </h2>
                </div>
              </div>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};
